'use client';

import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { ModalContentProps } from './Modal';

export default function ModalContent({ modalId, children }: ModalContentProps) {
  const [portalElement, setPortalElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    // Find the modal container by data attribute
    const modalContainer = document.querySelector(`[data-modal-id="${modalId}"]`) as HTMLElement;
    setPortalElement(modalContainer);
  }, [modalId]);

  if (!portalElement) {
    return null;
  }

  return createPortal(children, portalElement);
}

// Hook to easily render content in a modal
export function useModalContent(modalId: string) {
  return function ModalContentWrapper({ children }: { children: React.ReactNode }) {
    return <ModalContent modalId={modalId}>{children}</ModalContent>;
  };
}
